export const CTIME_OUT = 'TIME_OUT'